import React, {  useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './InternalUseOnlyComponent.metadata.json5';


import AdditionalConditionsofPolicyComponent from "../subcomponent/AdditionalConditionsofPolicy/AdditionalConditionsofPolicyComponent"
import SubjectsConditionsofQuoteComponent from "../subcomponent/SubjectsConditionsofQuote/SubjectsConditionsofQuoteComponent"

function InternalUseOnlyComponent(props) {

const { submissionVM, updateWizardData,pathUpdated} = props;
const breakpoint = useContext(BreakpointTrackerContext);
const { onValidate } = useValidation('InternalUseOnlyComponent');
var modelVM = _.get(submissionVM,pathUpdated)



// eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        }, 
        preFinComAppFie: {
            visible: !_.isUndefined(modelVM.value.isitPremiumFinancing) && modelVM.value.isitPremiumFinancing 
        },        
        additionalConditionsofPolicyComponent: {
            data: modelVM.pcladdConOfPolExps,
            updateWizardData,
            submissionVM,
            AdditionalConditionsofPolicyPath: `${pathUpdated}.pcladdConOfPolExps`            
            
        },
        subjectsConditionsofQuoteComponent: {
            data: modelVM.pclsubConOfQupExps,
            updateWizardData,
            submissionVM,
            SubjectsConditionsofQuotePath: `${pathUpdated}.pclsubConOfQupExps`
        }
    };


const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            additionalConditionsofPolicyComponent : AdditionalConditionsofPolicyComponent,
            subjectsConditionsofQuoteComponent : SubjectsConditionsofQuoteComponent
        }
    };

const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM,pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM,`${fullPath}`,value);

            updateWizardData(submissionVM);         
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={modelVM}
               // onModelChange={updateWizardData}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                onValueChange={handleValueChange}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
    );


}

InternalUseOnlyComponent.propTypes = wizardProps;
export default withRouter(InternalUseOnlyComponent);
